<template>
  <div>
    <b-overlay
      :show="loading"
      spinner-type="grow"
      spinner-variant="primary"
      :variant="`transparent`"
      :opacity="1"
      :blur="`2px`"
      rounded="sm"
    >
      <div class="d-flex flex-row mb-2">
        <b-button
          size="md"
          class="ml-auto"
          variant="primary"
          @click="addNewTag"
        >
          Add New Tag
        </b-button>
      </div>
      <b-table
        sticky-header="70vh"
        :items="tableData"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        show-empty
        responsive
      >
        <template #cell(name)="data">
          <span>
            {{ data.item.name }}
          </span>
        </template>
        <template #cell(action)="data">
          <b-form-group>
            <feather-icon
              v-for="menuItem in menuData"
              :id="menuItem.text + data.item.id"
              :key="menuItem.text"
              :icon="menuItem.icon"
              class="mr-50"
              size="20"
              @click="optionClicked(menuItem.text, menuItem.icon, data.item.id)"
            />
          </b-form-group>
        </template>
      </b-table>
    </b-overlay>
    <tag-create-update
      v-if="modalVisible"
      :tag.sync="selectedTag"
      :modal-visible.sync="modalVisible"
      @closeTagCU="hideModal"
      @success="getData"
    />
  </div>
</template>

<script>
import {
  BTable, BFormInput, BOverlay, BButton, BFormGroup,
} from 'bootstrap-vue'
import { analysError } from '@/_helpers/analys_error'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import useJwt from '@/auth/jwt/useJwt'
import SalariesPayoutView from '@/views/pages/finances/salaries/payout-view/SalariesPayoutView.vue'
import TagCreateUpdate from "@/views/pages/settings/components/TagCreateUpdate.vue";

export default {
  components: {
    BFormGroup,
    BButton,
    TagCreateUpdate,
    BTable,
    BFormInput,
    BOverlay,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      comradeTotalPaidCopy: '',
      modalVisible: false,
      selectedTag: null,
      sortBy: 'name',
      sortDesc: false,
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center',
        },
      ],
      menuData: [
        { icon: 'EditIcon', text: 'Edit' },
        //{ icon: 'DeleteIcon', text: 'Delete' },
      ]
    }
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    hideModal() {
      this.modalVisible = false;
    },
    addNewTag() {
      this.modalVisible = true;
    },
    getData() {
      this.loading = true;
      axios.get(`${process.env.VUE_APP_API_URL}/tags`, {
        headers: {
          Authorization: `Bearer ${useJwt.getToken()}`,
        },
      }).then(response => {
        this.loading = false;
        this.tableData = response.data.data;
        //this.totalRows = response.data.data.total
      }).catch(error => {
        this.loading = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: analysError(error.response),
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      })
    },
    optionClicked(text, icon, tagId = null) {
      if (text === 'Edit') {
        const tag = this.tableData.find(tag => tag.id === tagId)
        this.selectedTag = { ...tag }
        this.modalVisible = true;
        // this.editTransaction = { ...this.items.find(transaction => transaction.id === self.targetTransaction) }
      } else if (text === 'Delete') {
        //this.deleteTransaction(this.targetTransaction)
      }
    },
  },
}
</script>

<style scoped>

</style>
